import { createFileRoute } from '@tanstack/react-router';
import { GradeSubmissionScreen } from '@/quiz-submission/GradeSubmissionScreen';

/**
 * The group mount of the grade screen. Legacy's member template is a one-line
 * `require` of this group template
 * (`themes/wbs/buddypress/members/single/course-study/quiz_grade.php:1`), so the
 * form itself lives in `@/quiz-submission/` and both mounts share it — see
 * `GradeSubmissionScreen` for the shared behaviour (R30, R32, R34, X17).
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes/grade/$submissionId',
)({
  component: GroupQuizSubmissionGradeScreen,
});

function GroupQuizSubmissionGradeScreen() {
  const { submissionId } = Route.useParams();
  return (
    <GradeSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
